<template>
  <div>
    <van-form @submit="onSubmit">
      <van-cell class="daytitle" title="日期:" :value="form.time" @click="show = true" />
      <van-calendar  allow-same-day   :max-date="maxDate" :min-date="minDate" v-model="show" type="range" @confirm="onConfirm" />
    </van-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        time: '',
        start: '',
        end: '',
      },
      minDate: new Date(2000, 0, 1), // 设置一个过去的日期作为最小日期
      maxDate: new Date(new Date().getTime()), // 设置明天的日期作为最大日期
      show:false,
    }
  },
  methods: {
    formatDate(date) {
      return `${date.getMonth() + 1}/${date.getDate()}`;
    },
    onConfirm(date) {
      const [start, end] = date;
      this.show = false;
      this.form.start = `${start.getFullYear()}-${('0' + (start.getMonth() + 1)).slice(-2)}-${('0' + start.getDate()).slice(-2)}`;
      this.form.end = `${end.getFullYear()}-${('0' + (end.getMonth() + 1)).slice(-2)}-${('0' + end.getDate()).slice(-2)}`;
      this.form.time = `${this.form.start}至${this.form.end}`
      this.$emit('anytime', this.form.start, this.form.end);
    },
    onSubmit(){

    }
  },
  created() {
    // 初始化日期
    let date = [new Date(), new Date()];
    this.onConfirm(date)
  },
}
</script>

<style lang="scss" scoped>
@media screen and (max-width: 370px) {
  ::v-deep .van-button--danger {
    z-index: 999;
    position: fixed;
    left: 0;
    bottom: 280px;
  }
}
::v-deep{
    .daytitle{
        padding-left: 10px;
    }
    .van-form .van-cell__title{
        flex: 1;
        text-align: left;
    }
    .van-form .van-cell__value{
        flex: 5;
        text-align: left;
        margin-left: 5px;
    }
}
</style>
